import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import AppSidebarLayout from "../../components/AppSidebarLayout";
import { PageTitle, Panel, Pill, Row, RowGroup } from "../../components/dashboard/DashboardBits";
import { ALL_INVENTORY_TASKS } from "./mockDashboardData";
// Mock only -- flat cross-item view of every maintenance task (the "Maintenance Tasks" sidebar
// child), distinct from the per-item grouping on the Home Inventory overview page. Same
// mockDashboardData source, sorted overdue-first so what needs attention reads at a glance.
const TONE_ORDER = { overdue: 0, due: 1, track: 2, accent: 3, neutral: 4 };
const SORTED_TASKS = [...ALL_INVENTORY_TASKS].sort((a, b) => TONE_ORDER[a.tone] - TONE_ORDER[b.tone]);
export default function InventoryTasksPage() {
    return (_jsx(AppSidebarLayout, { children: _jsxs(Box, { sx: { p: 2 }, children: [_jsx(PageTitle, { children: "Maintenance Tasks" }), _jsx(Panel, { title: "All tasks", remote: "home-inventory", children: _jsx(RowGroup, { children: SORTED_TASKS.map((t) => (_jsx(Row, { icon: undefined, title: t.title, subtitle: `${t.itemName} · ${t.detail}`, right: _jsx(Pill, { label: t.due, tone: t.tone }) }, t.id))) }) })] }) }));
}
